import { render, staticRenderFns } from "./CassaFilter.vue?vue&type=template&id=05069607&"
import script from "./CassaFilter.vue?vue&type=script&lang=ts&"
export * from "./CassaFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports